import { EventEmitter } from '@angular/core';
import { NameUserAssignmentComponent } from '@app/shared';

export class AssignmentConfig {
  // se emite cada vez que se realiza una accion con los botones de la tabla
  accion: EventEmitter<any> = new EventEmitter();
  // contiene la configuracion de la tabla
  settings = {};

  constructor () { }

  /**
   * Retorna la configuracion de la tabla para el historial de asignaciones
   *
   * @returns
   * @memberof AssignmentConfig
   */
  getSettingsTableRejects() {
    const self = this;
    return {
      mode: 'external',
      noDataMessage: 'Actualmente no hay historial',
      actions: false,
      attr: {
        class: 'table-bordered table-hover'
      },
      columns: {
        fecha_registro: {
          editable: false,
          addable: false,
          title: 'Fecha inicio asignacion',
          filter: {
            inputClass: 'form-control',
          },
        },
        fecha_finalizacion: {
          editable: false,
          addable: false,
          title: 'Fecha de asignacion',
          filter: {
            inputClass: 'form-control',
          },
        },
        responsable: {
          editable: false,
          addable: false,
          title: 'Responsables',
          filter: {
            inputClass: 'form-control',
          },
        },
        usuarios_asignados: {
          editable: false,
          addable: false,
          title: 'Usuarios asignados',
          filter: {
            inputClass: 'form-control',
          },
        },
        fecha_rechazo: {
          editable: false,
          addable: false,
          title: 'Fecha de rechazo',
          filter: {
            inputClass: 'form-control',
          },
        },
        descripcion: {
          editable: false,
          addable: false,
          title: 'Motivo de rechazo',
          filter: false,
        },
        responsable_rechazo: {
          editable: false,
          addable: false,
          title: 'Responsable del rechazo',
          filter: {
            inputClass: 'form-control',
          },
        },
      },
    };
  }

  /**
   * Retorna la configuracion de la tabla para los usuarios del grupo seleccionado
   *
   * @returns
   * @memberof AssignmentConfig
   */
  getSettingsTableAssignment() {
    const self = this;
    return {
      mode: 'external',
      noDataMessage: 'Actualmente no hay usuarios para el grupo seleccionado',
      actions: false,
      attr: {
        class: 'table-bordered table-hover'
      },
      columns: {
        nombre: {
          editable: false,
          addable: false,
          sortDirection: 'asc',
          title: 'Funcionario',
          filter: {
            inputClass: 'form-control',
          },
          type: 'custom',
          renderComponent: NameUserAssignmentComponent,
        },
        sede: {
          editable: false,
          addable: false,
          title: 'Dependencia',
          filter: {
            inputClass: 'form-control',
          },
        },
        asignaciones: {
          editable: false,
          addable: false,
          title: 'Cantidad de asignaciones',
          filter: false,
        },
      },
    };
  }

}



// WEBPACK FOOTER //
// ./src/app/forms/shared/assignment/shared/assignment.config.service.ts